import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { marker as extractTranslation } from '@colsen1991/ngx-translate-extract-marker';
import { TranslateService } from '@ngx-translate/core';
import { NkToastrService } from '../nk-toastr/nk-toastr.service';

function copyToClipboard(text: string): boolean {
  const input = document.createElement('input');
  input.setAttribute('value', text);
  document.body.appendChild(input);
  input.select();
  const result = document.execCommand('copy');
  document.body.removeChild(input);
  return result;
}

@Component({
  selector: 'nk-text-copy-wrapper',
  imports: [],
  templateUrl: './text-copy-wrapper.component.html',
  styleUrls: ['./text-copy-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextCopyWrapperComponent {
  public text = input<string>();
  public disableClipboardCopy = input<boolean>(false);
  public successMessage = input<string>(extractTranslation('clipboard_copy.message_copied'));
  private _translateService = inject(TranslateService);
  private _toastr = inject(NkToastrService);

  public copyToClipboard(event: Event, text: string | undefined): void {
    if (this.disableClipboardCopy() || !text) {
      return;
    }
    event.stopPropagation();
    event.preventDefault();
    copyToClipboard(text);
    const message = this._translateService.instant(this.successMessage()) as string;
    this._toastr.info(text, `${message}:`, {
      timeOut: 1000,
    });
  }
}
